import React, { useState } from 'react';

import { Box, Stack, Tab, Tabs } from '@mui/material';

import { TourDetailsContextProvider } from '../TourDetails/TourDetailsContext';

import NativeTourSalesforceInventory from './NativeTourSalesforceInventory';
import NativeTourSlidingScale from './NativeTourSlidingScale';

interface Props {
  legacyTourId: string;
  tourName: string;
}

type PricingArea = 'pricing' | 'salesforce';

/** Cost prices, departures and inventory on the new model, and Salesforce's live inventory beside them. */
export default function NativeTourPricingSection({ legacyTourId, tourName }: Props) {
  const [area, setArea] = useState<PricingArea>('pricing');

  return (
    <Stack spacing={2}>
      <Tabs
        value={area}
        onChange={(_event, next: PricingArea) => setArea(next)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="pricing" label="Cost price and inventory" />
        <Tab value="salesforce" label="Salesforce inventory" />
      </Tabs>
      <Box>
        {area === 'pricing' ? (
          <TourDetailsContextProvider>
            <NativeTourSlidingScale legacyTourId={legacyTourId} tourName={tourName} />
          </TourDetailsContextProvider>
        ) : (
          <NativeTourSalesforceInventory legacyTourId={legacyTourId} />
        )}
      </Box>
    </Stack>
  );
}
